import React, { useEffect, useMemo, useState } from "react";
import {Dialog, TextField} from "@material-ui/core";
import {Field, FieldProps, Form, Formik} from "formik";
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";
import InputMask from "react-input-mask";
import './index.scss';
import config from "../../../config";

interface ITravelConfirmDialogProps {
    isOpen: boolean;
    onSubmit: (code: string) => Promise<void>;
    onCancel: () => Promise<void>;
    phoneNumber: string;
    controlCode: string;
}

/*
    Це модалка яка зявляється після того, як ти ввів номер та дату 
    І саме тут потрібно ввести код з смски
*/

export const TravelConfirmDialog = (props: ITravelConfirmDialogProps) => {
    const {isOpen, phoneNumber, controlCode, onCancel, onSubmit} = props;
    const [process, setProcess] = useState(false);
    const [sendAgainProcess, setSendAgainProcess] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(0);
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        if (isOpen) {
            setSecondsLeft(config.verification.resendTimeout)
        }
    }, [isOpen]);

    useEffect(() => {
        const timer = secondsLeft > 0 && setInterval(() => setSecondsLeft(secondsLeft - 1), 1000);
        return () => clearInterval(timer);
    }, [secondsLeft]);

    const sendAgain = async () => {
        setSendAgainProcess(true);
        await onCancel();
        setSendAgainProcess(false);
        setSecondsLeft(config.verification.resendTimeout)
    }

    const sendAgainBtnLbl = useMemo(() => {
        if (secondsLeft > 0) return `${strings.sendAgain} (${secondsLeft})`;
        return strings.sendAgain;
    }, [secondsLeft]);

    return (
        <Dialog open={isOpen} disableBackdropClick={true}>
            <div className={"dialog travel-confirm-dialog"}>
                <Formik initialValues={{
                    code: "W"
                }} onSubmit={async values => {
                    try {
                        setErrorMessage('');
                        setProcess(true);
                        await onSubmit(values.code);
                        setProcess(false);
                    } catch (e) {
                        setErrorMessage(strings.wrongCode);
                        setProcess(false);
                    }
                }}
                >
                    {formProps => (
                        <Form>
                            <div className={"dialog__content"}>
                                <span className={"dialog__title travel-confirm-dialog__title"}>{strings.mtplPhoneNumberConfirmDlg.text1}</span>

                                <p className={"dialog__message travel-confirm-dialog__message"}>
                                    {strings.mtplPhoneNumberConfirmDlg.text2}<span>+{phoneNumber}</span>{strings.mtplPhoneNumberConfirmDlg.text3}
                                </p>

                                <Field name={"code"}>
                                    {({field, form, meta}: FieldProps) => (
                                        <InputMask
                                            className='travel-confirm-dialog__input'
                                            {...field}
                                            mask={"W99999"}
                                            maskChar={"_"}
                                            alwaysShowMask={true}>
                                            {
                                            //@ts-ignore
                                            (field: any) => (
                                                <TextField {...field}
                                                           fullWidth={true}
                                                           helperText={
                                                               errorMessage !== '' ? errorMessage : `${strings.controlCode} ${controlCode}`
                                                           }
                                                           error={errorMessage !== ''}
                                                           variant="outlined"
                                                           label={strings.code}
                                                           InputProps={{
                                                               ...field.InputProps,
                                                               shrink: true,
                                                           }}/>)}
                                        </InputMask>
                                    )}
                                </Field>

                                <Button label={'Підтвердити'}
                                        isProcess={process}
                                        onClickListener={formProps.handleSubmit}/>

                                <Button label={sendAgainBtnLbl}
                                        variant={secondsLeft > 0 ? 'link' : 'notSelected'}
                                        onClickListener={sendAgain}
                                        isProcess={sendAgainProcess}
                                        disabled={secondsLeft > 0}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Dialog>
    )

}